var _style, _path, _path2, _polygon, _polygon2, _path3, _path4, _path5, _polygon3, _polygon4, _polygon5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 55",
    style: {
      enableBackground: "new 0 0 120 55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#949480;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M10.8,17.5H5v7.6H0V0h10.9c5.1,0,8.8,3.7,8.8,8.8c0,3.2-1.5,6-4,7.5l5.6,8.9l-5.9,0L10.8,17.5z  M13.1,11.9c1.1-0.6,1.6-1.8,1.6-3.2c0-2.2-1.4-3.7-3.8-3.7H5v7.5h2.6C8.9,12.5,11.7,12.6,13.1,11.9L13.1,11.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "st0",
    d: "M40.1,0l11.6,25.1h-5.5l-1.8-3.9H31.3l-1.8,3.9h-5.5L35.5,0H40.1z M37.8,6.9l-4.2,9.3h8.5 L37.8,6.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    className: "st1",
    points: "0,29.9 0,55 5,55 5,45 16.1,45 16.1,39.9 5,39.9 5,34.9 16.1,34.9 16.1,29.9 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    className: "st1",
    points: "66.9,29.9 66.9,46.4 53.4,29.9 49,29.9 49,55 54,55 54,38.5 67.5,55 71.9,55 71.9,29.9 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    className: "st1",
    d: "M109.6,29.9c4.2,0,7.4,2.2,8.3,6.3l-4.5,1.8c-0.5-2.3-1.9-3.2-3.8-3.2c-2,0-3,1-3,2.2 c0,1.8,1.9,2.3,4.6,3.2c3.4,1.1,6.6,2.8,6.6,7.4c0,4.7-3.5,7.3-8.1,7.3c-3.9,0-7.4-1.9-8.4-6.3l4.5-1.9c0.5,2.2,1.8,3.3,3.9,3.3 c1.9,0,3-0.9,3-2.3c0-1.9-2-2.4-4.4-3.1c-3.1-1-6.7-2.7-6.7-7.5C101.5,32.5,104.9,29.9,109.6,29.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    className: "st1",
    d: "M44.4,29.9v13.5c0,6.9-5,11.6-11.6,11.6c-6.6,0-11.6-4.7-11.6-11.6V29.9h5v13.5 c0,4.1,2.9,6.6,6.6,6.6c3.8,0,6.6-2.5,6.6-6.6V29.9H44.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-18",
    className: "st1",
    d: "M85.5,29.9c7.1,0,12.3,5.3,12.3,12.6S92.6,55,85.5,55h-9.1V29.9H85.5z M85.5,34.9h-4.1V50h4.1 c4.3,0,7.3-3.2,7.3-7.5C92.8,38.1,89.8,34.9,85.5,34.9L85.5,34.9z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    className: "st1",
    points: "120,0.4 115.3,0.4 105,18.5 94.7,0.4 90,0.4 90,25 94.9,25 94.9,10.7 103,25 106.8,25  115.1,10.4 115.1,25 120,25 120,2 120,2 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    className: "st1",
    points: "86.1,24.7 81.2,24.7 81.2,18 86.1,9.4 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    className: "st0",
    points: "86.3,1.7 86.3,0 81.5,0 71,18.5 60.4,0 55.6,0 55.6,25.1 60.6,25.1 60.6,10.5 68.9,25.1  73,25.1 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.812f1052.svg";
export { ForwardRef as ReactComponent };